import type { ButtonHTMLAttributes } from 'react'
import React from 'react'
import classNames from 'classnames'

import type { Icon } from '@slite/icons'

import type { BaseMenuItemProps } from './BaseMenuItem'
import { BaseMenuItem, BaseMenuItemContent } from './BaseMenuItem'

export type MenuHeaderProps = ButtonHTMLAttributes<HTMLButtonElement> &
  Omit<BaseMenuItemProps, 'children' | 'onClick'> & {
    icon?: Icon
    'data-test-id'?: string
  }

export const MenuHeader = ({
  icon,
  children,
  tooltip,
  'data-test-id': dataTestId,
  style,
  className,
}: MenuHeaderProps) => {
  return (
    <BaseMenuItem tooltip={tooltip}>
      {(_className) => (
        <div
          className={classNames(
            _className,
            'uppercase letter-spacing-small shade-30 font-size-smaller font-weight-bold cursor-default padding-top-12 padding-bottom-8 padding-horizontal-8',
            className
          )}
          data-test-id={dataTestId}
          style={style}
        >
          <BaseMenuItemContent icon={icon}>{children}</BaseMenuItemContent>
        </div>
      )}
    </BaseMenuItem>
  )
}
